<scaffold-dialog [title]="'Select one of the quick help options below to start an interactive tour.'" [fit]="true">
  <div scaffoldDialogBody>
    <div *ngFor="let tour of tours">
      <p><a (click)="startTour(tour)">{{ tour.title }}</a></p>
    </div>
  </div>
</scaffold-dialog>
